import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.salesrep/territory-manager/region/region-edit.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from "ioc/resolve";
import modals from 'webmodals/modals'
import TerritoryPicker from 'emun.salesrep/territory-manager/territory/picker/territory-picker'
import ZipcodePicker from 'emun.salesrep/territory-manager/zipcode/picker/zipcode-picker'
import ServiceBus from "servicestack/service-bus";

class RegionEditController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
	}
	$onInit() {
		const $ctrl = this;
		const id = $ctrl.regionId;
		$ctrl.bus = new ServiceBus();
		if (id == "create") {
			$ctrl.region = { id: "create" };
		} else {
			let options = {
				url: "QueryRegions.json?Id=" + id,
				autoLoad: true,
				append: false,
				pageSize: 24,
				onLoaded: args => {
					$ctrl.region = args.first;
				}
			};
			$ctrl.query = new AutoQuery(options);
		}
		$ctrl.zipcodes = new AutoQuery({
			url: "QueryZipcodes.json",
			criteria: {
				RegionId: id
			},
			autoLoad: true
		});
		$ctrl.territories = new AutoQuery({
			url: "QueryTerritories.json",
			criteria: {
				RegionId: id
			},
			autoLoad: true
		});
	}
	submit(close) {
		const $ctrl = this;
		const action = `${$ctrl.region.id == "create" ? "Cre" : "Upd"
			}ateRegion.json`;

		return $ctrl.bus.send(action, $ctrl.region).then((res) => {
			$ctrl.region.id = res.data.id;
			$ctrl.territories.criteria.RegionId = $ctrl.region.id;
			$ctrl.zipcodes.criteria.RegionId = $ctrl.region.id;
			if (close) resolve("$state").go("regions");
		});
	}

	addTerritory() {
		let $ctrl = this;
		$ctrl.territoryIds = [];

		return TerritoryPicker({
			title: "Select Territories...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.submit().then(function (res) {
				$ctrl.bus.send("AddRegionTerritories", {
					RegionId: $ctrl.region.id,
					TerritoryIds: result
				}).then(function (response) {
					$ctrl.territories.load();
				});
			});
		});
	}
	addZipcode() {
		let $ctrl = this;
		$ctrl.zipcodeIds = [];

		return ZipcodePicker({
			title: "Select Zipcodes...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.submit().then(function (res) {
				$ctrl.bus.send("AddRegionZipcodes", {
					RegionId: $ctrl.region.id,
					ZipcodeIds: result
				}).then(function (response) {
					$ctrl.zipcodes.load();
				});
			});
		});
	}

	deleteTerritory(territory) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + territory.name, "Remove Territory?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRegionTerritory.json", {
						RegionId: $ctrl.region.id,
						TerritoryId: territory.id
					})
					.then(function () {
						return $ctrl.territories.load(true);
					})
					.catch(

					);
			});
	}
	deleteZipcode(zipcode) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + zipcode.id, "Remove Zipcode?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRegionZipcode.json", {
						RegionId: $ctrl.region.id,
						ZipcodeId: zipcode.id
					})
					.then(function () {
						return $ctrl.zipcodes.load(true);
					})
					.catch(

					);
			});
	}

}

let RegionEdit = {
	controller: RegionEditController,
	bindings: {
		regionId: "@"
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default RegionEdit;
